import {Injectable, Injector} from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpXsrfTokenExtractor, HttpErrorResponse, HttpEvent, HttpResponse } from "@angular/common/http";
import {catchError, take, tap} from 'rxjs/operators';
import {environment} from '../environments/environment';
import {Observable, throwError} from 'rxjs';
import {Router} from '@angular/router';
import {ToastService} from '../../../shared/src/lib/services/toast.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(private tokenExtractor: HttpXsrfTokenExtractor, private toastService: ToastService,
              private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (request.url.indexOf(environment.baseUrl) === 0 && request.url.indexOf('token-auth') === -1) {
      let requestOptions;
      if (request.method.toLowerCase() !== 'get' && request.method.toLowerCase() !== 'options') {
        requestOptions = {
          setHeaders: {'X-CSRFToken': this.tokenExtractor.getToken()},
          withCredentials: true
        };
      } else {
        requestOptions = {
          withCredentials: true
        };
      }
      request = request.clone(requestOptions);
    }
    return next.handle(request).pipe(
      tap(evt => {
        if (evt instanceof HttpResponse) {
          if (evt.status === 201 || evt.status === 200 || evt.status === 204) {
            if (request.method.toLowerCase() === 'put' || request.method.toLowerCase() === 'post') {
              this.toastService.success('Successfully saved.');
            } else if (request.method.toLowerCase() === 'delete') {
              this.toastService.warning('Successfully deleted.');
            }
          }
        }
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          // try {
          //   this.toastService.warning(err.message);
          //   // this.toastService.warning('An error occurred');
          // } catch (e) {
          if (err.status !== 403) {
            this.toastService.error('An error occurred');
          }
          // }
          // log error
          if (err.status === 403) {
            this.router.navigate(['login']);
          }
        }
        return throwError(err);
      }),
    );
    // next.handle(request).pipe(
    //   catchError(err => {
    //      return this.route.paramMap.pipe(tap((params: ParamMap) => {
    //         const next_route = params.get('name');
    //         if (err instanceof HttpErrorResponse && err.status == 401 && next_route !== 'login') {
    //           let next = `${next_route}`;
    //           if (next_route !== null && next_route.indexOf('details') > -1) next += `:${params.get('id')}`;
    //           this.router.navigate(['login', {'next': next}]);
    //         }
    //       }
    //     ))
    //   }));
  }
}
